import styles from './styles.module.scss'
import classNames from 'classnames'
import { PayGoLimitsContent } from 'src/Modals/UpgradePlanModal/Step1Upgrade/cards/PayGoLimitsContent'

export const PayGoLimits = () => (
  <div className={classNames(styles.card, styles.left)}>
    <PayGoLimitsContent />
  </div>
)
